<script lang="ts">
    import SvgIcon from "../SVGIcon.svelte";

    export let card;

    const author = card?.author ? processAuthorDetails(card.author) : null;

    function processAuthorDetails(author) {
        const name = author.name?.length
            ? decodeURIComponent(author.name)
            : `${getPlatformFromUrl(author.url ?? "")} User`;
        const username = author.username?.length
            ? decodeURIComponent(author.username)
            : "Unknown";
        const url = author.url ?? "javascript:void(0)";
        const image = author.image?.length ? author.image : null;

        return { name, username, url, image };
    }

    function getPlatformFromUrl(
        url: string,
    ): "LinkedIn" | "Twitter" | "Unknown" {
        try {
            const hostname = new URL(url).hostname;

            if (hostname.includes("linkedin.com")) return "LinkedIn";
            else if (
                hostname.includes("twitter.com") ||
                hostname.includes("x.com")
            )
                return "Twitter";
        } catch {
            console.error("Invalid URL for checking platform of card author");
        }

        return "Unknown";
    }
</script>

{#if author}
    <div class="author-banner">
        {#if author.image}
            <img
                class="author-banner__image"
                src={author.image}
                alt={author.name}
            />
        {:else}
            <SvgIcon
                name="user-circle"
                size="32"
                height="32"
                strokeWidth="1.2"
            />
        {/if}
        <div class="author-banner__details">
            <div class="author-banner__name">{author.name}</div>
            <a
                href={author.url}
                target="_blank"
                class="author-banner__username"
            >
                @{author.username}
            </a>
        </div>
    </div>
{/if}

<style>
    .author-banner {
        @apply relative flex items-center gap-1 px-4 pt-2 !important;
    }

    .author-banner__image {
        @apply h-8 w-8 rounded-full !important;
    }

    .author-banner__details {
        @apply flex flex-col !important;
    }

    .author-banner__name {
        @apply text-sm font-semibold text-gray-900 !important;
    }

    .author-banner__username {
        @apply text-xs text-gray-500 no-underline !important;
    }
</style>
